import haversineDistance from '@shared/helpers/haversineDistance';
import { LatLng } from '@shared/types/locations';

export const distanceFromStoreKm = (
  myLocation: LatLng,
  store: Partial<{ lat: number; lng: number }>,
) => {
  const distanceInMetres = haversineDistance(
    { latitude: myLocation.lat, longitude: myLocation.lng },
    { latitude: store.lat, longitude: store.lng },
  );

  // eslint-disable-next-line no-magic-numbers
  return distanceInMetres / 1000;
};
